import fetch from './fetch';
import EndPoints from '../data/EndPoints';
import Methods from '../data/Methods';

export default (data) => {
	return fetch(Methods.POST, EndPoints.FINANCIAL_STATEMENT, data, null, true, true, false, true);
};
